export default {
  VESTING: "0x1307E214dFcD33F0639d4F8725bD628c0E79E734",
  XRT: "0x7dE91B204C1C737bcEe6F000AAA6569Cf7061cb7",
  GRANTS: "0x3D32537f569c1E96270c1640106438f156388a91"
};
